/**
 * loại chương trình dự án
 */
export default {
  Construction: 3, // Công trình
  WorkItem: 4, // Hạng mục công trình
};
